import { MainLayout } from "@/components/layout/MainLayout";
import { SIDEBAR_LINKS } from "@/components/layout/navLinks";
import { NotFoundPage } from "@/components/not-found/NotFoundPage";
import { useProfile } from "@/queries/customer/customer";
import { queryClient } from "@/queries/queryClient";
import { sellerListQuery } from "@/queries/sellers";
import { createRoute, Outlet } from "@tanstack/react-router";
import { searchProviderRoute } from "./$searchProviderRoute";
import { regionsQuery } from "@/queries/regions";

export const layoutRoute = createRoute({
  getParentRoute: () => searchProviderRoute,
  id: "layout", // Pathless route - no path property
  loader() {
    // preload seller list
    queryClient.ensureQueryData(sellerListQuery());
    queryClient.ensureQueryData(regionsQuery());
  },
  component: Layout, // Just render children
  // For a `notFound()` thrown by a page in this shell. An unmatched URL does
  // not come through here - it is `notFoundRoute`'s - but both render the same
  // page inside the shell, so the sidebar and header stay put either way.
  notFoundComponent: NotFoundPage
});

function Layout() {
  const { data } = useProfile();

  return (
    <MainLayout links={SIDEBAR_LINKS} profile={data!.customer}>
      <Outlet />
    </MainLayout>
  );
}
